<template>
  <div>
    <h1>PageNotFound</h1>
  </div>
</template>

<script>
export default {
  name: "PageNotFound",
};
</script>
